import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Editor from '@geerdsolutions/ck-geerd-text-editor';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useUploadImage } from '@geerd-nx/hooks';
import { CkOutput } from './CkOutput';
const CkRichTextEditor = ({
  value,
  onChange,
  onBlur,
  urlPrefix,
  index = 1,
  withPasting = true,
}: {
  urlPrefix: string;
  value?: string;
  onChange: any;
  onBlur?: any;
  index?: number;
  withPasting?: boolean;
}) => {
  function uploadAdapter(loader: any) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file.then((file: any) => {
            uploadImage({ file })
              .then((path) => {
                resolve({ default: path });
              })
              .catch((err) => reject(err));
          });
        });
      },
    };
  }

  function uploadPlugin(editor: any) {
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any
    ) => {
      return uploadAdapter(loader);
    };
  }

  function WordCount(editor: any) {
    editor.plugins.get('WordCount').on('update', (_: any, stats: any) => {
      const wordCountWrapper = document.getElementById(`word-count-${index}`);
      const wordCountPlugin = editor.plugins.get('WordCount');
      wordCountWrapper?.appendChild(wordCountPlugin.wordCountContainer);
    });
  }
  function disablePaste(editor: any) {
    editor.plugins
      .get('ClipboardPipeline')
      .on('contentInsertion', (evt: any, data: any) => {
        evt.stop();
      });
  }

  const extraPlugins = withPasting
    ? [uploadPlugin, WordCount]
    : [uploadPlugin, WordCount, disablePaste];

  const { uploadImage } = useUploadImage('qhd', urlPrefix);
  return (
    <>
      <CKEditor
        config={{
          extraPlugins,
        }}
        editor={Editor}
        data={value}
        onChange={onChange}
        onBlur={onBlur}
        // disabled={true}
      />
      <div id={`word-count-${index}`}></div>
    </>
  );
};
export { CkOutput, CkRichTextEditor };
